import { fermentStages } from "@/mocks/events";
import { SectionHeading } from "@/components/base/Shared";
import Reveal from "@/components/base/Reveal";

export default function FermentStages() {
  return (
    <section id="stages" className="bg-background-100 border-y border-background-200 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="FERMENT PATH"
          title="一条爆料要经过四个阶段才会真正出圈"
          desc="热度不是一瞬间冲上去的。从首爆到上热搜，中间每一步都决定了事件能走多远，也决定了它会以多快的速度回落。"
          align="center"
        />

        <div className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-4">
          <div className="hidden lg:block absolute top-[48px] left-[12%] right-[12%] h-px bg-background-300" />
          {fermentStages.map((stage, index) => (
            <Reveal key={stage.step} delay={index * 90}>
              <article className="relative h-full rounded-2xl bg-background-50 border border-background-200 p-6">
                <div className="flex items-center justify-between">
                  <span className="relative z-10 w-12 h-12 rounded-xl bg-background-50 border-2 border-primary-300 text-primary-600 flex items-center justify-center font-heading text-lg font-bold">
                    {stage.step}
                  </span>
                  <span className="text-xs font-label text-secondary-700 bg-secondary-50 px-2.5 py-1 rounded-md whitespace-nowrap">
                    {stage.window}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{stage.name}</h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{stage.desc}</p>
                <p className="mt-5 pt-4 border-t border-background-200 text-xs font-label text-foreground-500 flex items-center gap-2">
                  <span className="w-4 h-4 flex items-center justify-center text-accent-600">
                    <i className="ri-focus-3-line" />
                  </span>
                  {stage.signal}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}